<template>
  <layout title="Notices">
    <div class="row mb-4">
      <div class="col-10">
        <h2 class="page-heading">Notices</h2>
      </div>

      <div class="col-2">
        <inertia-link
          class="btn btn-primary float-right"
          :href="route('notices.create')"
        >
          + Add New
        </inertia-link>
      </div>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
      <div class="card-body">
        <FlashMessage :flash="flash" />
        <div class="row mb-2">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <form @submit.prevent="search()">
              <input
                v-model="search_query"
                type="text"
                class="form-control"
                placeholder="Search.."
              />
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table">
              <thead class="thead-light xthead-dark">
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Notice</th>
                  <th scope="col">Target</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="notice in notices.data"
                  :key="notice.id"
                  @click="navigateToEdit(notice.id)"
                >
                <td>{{ notice.title }}</td>
                  <td>
                    {{ notice.notice.length > 20 
                      ? notice.notice.substr(0, 20) + '...' 
                      : notice.notice 
                    }}
                  </td>
                  <td>{{ notice.target_role }}</td>
                  <td>{{ notice.created_at }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm x-btn-danger btn-outline-danger"
                      @click.stop="showDeleteConfirmationModal(notice)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!notices.data || !notices.data.length">
                <tr>
                  <td colspan="5">No data to display</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-end">
            <li
              class="page-item"
              :class="{ active: link.active }"
              v-for="link in notices.meta.links"
              :key="link.label"
            >
              <inertia-link
                v-if="link.url"
                class="page-link"
                :href="link.url"
                preserve-scroll
              >
                <span v-html="link.label"></span>
              </inertia-link>
              <span class="page-link" v-else>
                <span v-html="link.label"></span>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div
      class="modal fade"
      id="deleteConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Record - {{ selectedRecord && selectedRecord.title }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete the record -
            <strong>{{ selectedRecord && selectedRecord.title }}</strong>
            ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="deleteRecord(selectedRecord ? selectedRecord.id : null)"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    notices: Object,
    search_query: String,
    flash: Object,
  },
  data() {
    return {
      selectedRecord: null,
    };
  },
  methods: {
    search() {
      this.$inertia.get(route("notice.index"), {
        search_query: this.search_query,
      });
    },
    showDeleteConfirmationModal(record) {
      this.selectedRecord = record;
      $("#deleteConfirmationModal").modal("show");
    },
    deleteRecord(id) {
      this.$inertia.delete(route("notices.destroy", id));
    },
    navigateToEdit(Id) {
      this.$inertia.get(route("notices.edit", Id));
    },
  },
};
</script>